import React, { useState } from 'react'
import { Gate, gateType } from './gate'
import _ from 'lodash'
import { useDrop } from 'react-dnd'
import { DualGate } from './dualGate'
import handleGates from './HandleGates'
import InfoDrawer from './InfoDrawer'
import info from './info'
import {MathJax} from 'better-react-mathjax'

type propType = {
    id: number,
    title: string,
    accepted: number[]
}

const Line = (props: propType) => {
    var gatesContainer = handleGates.useContainer()
    var gates = gatesContainer.gates && !_.isEmpty(gatesContainer.gates.filter(i => i.key == props.id)) ?
        gatesContainer.gates.filter(i => i.key == props.id)[0].items : []
    const [selectedGate, setSelectedGate] = useState<gateType | null>(null)
    const handleDrop = (item: gateType, monitor: any) => {
        const dropPosition = monitor.getClientOffset();
        const itemType = monitor.getItemType();
        gatesContainer.addNewGate(item, props.id)
    };

    const [{ isOver }, drop] = useDrop(() => ({
        accept: props.accepted.map(a => "gate_" + a),
        drop: handleDrop,
        collect: (monitor) => ({
            isOver: !!monitor.isOver(),
        }),
    }));


    return (
        <>
            <div className='flex h-10 items-center flex-row my-1 min-w-max'>
                <span className='w-16 pr-0'>
                    <MathJax>{props.title}</MathJax>
                </span>
                <div ref={drop} className="w-full relative min-h-[70%]">
                    <span className='border absolute block w-full top-[50%] z-[1]'></span>
                    <div className='pl-4'>
                        <div className="flex flex-row items-center justify-items-center gap-x-4">
                            {gates.map((item, index) => (
                                <div className='w-12 flex flex-none justify-center'>
                                    {(item.type == 1 || item.type== 3 || item.type ==2) ?
                                        <DualGate showInfoDrawer={() => setSelectedGate(item)} addRatio={(ratio: string) => gatesContainer.updateGate(index, props.id, ratio)} deleteGate={() => gatesContainer.deleteGate(index, props.id)} showOptions={true} gate={item} />
                                        :
                                        <Gate showInfoDrawer={() => setSelectedGate(item)} addRatio={(ratio: string) => gatesContainer.updateGate(index, props.id, ratio)} deleteGate={() => gatesContainer.deleteGate(index, props.id)} showOptions={true} gate={item} />
                                    }
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            {selectedGate ?
                <InfoDrawer closeModal={() => setSelectedGate(null)} text={info[selectedGate.name].information} />
                : null}
        </>
    )
}

export default Line


